import React, { useRef } from 'react'
import PropTypes from 'prop-types';
import { Button, Modal, Signature } from '../components';
import { useModal } from '../hooks';

const AttestationAndUndertaking = ({ onChange, value, onNext, onPrevious, isPassed }) => {

  const signatureRef = useRef()
  const [isOpen, onOpen, onClose] = useModal()

  const onClear = e => {
    e.preventDefault()
    signatureRef.current.clear()
  }

  const handleAttach = e => {
    e.preventDefault()
    onChange({
      target: {
        name: 'signature',
        value: signatureRef.current.toDataURL()
      }
    })
    
    onClose()
  }

  const handleOpenModal = e => {
    e.preventDefault()
    onOpen()
  }

  return (
    <>
      <div className="py-10">
        <div className="flex flex-col p-10">
          <p>
            &emsp;&emsp;&emsp;I, <span className="border-b">John Doe</span> do hereby ATTEST that the foregoing
            information are complete, true and correct to the best of my knowledge and belief. I commit to inform the
            Board in writing any subsequent changes in this data sheet within 15 days from knowledge thereof.
          </p>
          <div className="flex flex-col w-auto justify-center self-center">
            {value.signature ? <img className="h-32 w-64 m-auto" src={value.signature} alt="Client Signature" /> : <div className="h-32 w-64 m-auto"/>}
            <p className="text-center">John Doe</p>
            <p className="border-t text-center">Signature Over Printed Name</p>
          </div>
        </div>
        <div className="flex space-x-2 justify-end">
          <Button onClick={handleOpenModal} className="!bg-gray-600 !w-auto h-16">Attach Signature</Button>
        </div>
      </div>
      <div className="flex space-x-2 float-right">
        <Button type="button" onClick={onPrevious} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button  type="button" onClick={onNext} className="!w-auto">Proceed</Button>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="w-full h-64 p-5">
          <Signature ref={signatureRef} />
        </div>
        <div className="flex space-x-2 px-5">
          <Button onClick={onClear} type="button" className="!bg-gray-300 !text-primary">Clear</Button>
          <Button onClick={handleAttach} type="button">Attach</Button>
        </div>
      </Modal>
    </>
  )
}


AttestationAndUndertaking.propTypes = {
  value: PropTypes.shape({
    signature: PropTypes.string
  }).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  onNext: PropTypes.instanceOf(Function).isRequired,
  onPrevious: PropTypes.instanceOf(Function).isRequired,
  isPassed: PropTypes.bool.isRequired
}

AttestationAndUndertaking.displayName = 'AttestationAndUndertaking'

export default AttestationAndUndertaking

